import { AddressModel } from './AddressModel';

export class DeliveryDetailsModel {
    public title: string = '';
    public firstName: string = '';
    public surname: string = '';
    public phone: string = '';
    public allowPhoneContacts: boolean = false;
    public allowEmailContacts: boolean = false;

    public deliveryAddress: AddressModel | null;
    public billingAddress: AddressModel | null;
}